// routes/reset-password.tsx
import { dynamic } from 'src/utils/ssr'

const getClientModule = () => import('src/clientRoutes/reset-password')

export const handle = { name: 'reset-password' }

export default dynamic(getClientModule, { ssr: false })
